import { SelectionOption } from '@cash-web/protos/squareup/franklin/blockers/selection_blocker.pb'

import { MAGIC_LINK_PRIMARY_ACTION } from './constants'
export const isMagicLinkAction = (option: SelectionOption) => {
  return option.action === MAGIC_LINK_PRIMARY_ACTION
}
